import {
  getConsultList,
  addConsult,
  getConsultDetail,
  editConsultDetail, delConsult,
} from '../../services/consult'

export default {
  state: {},
  mutations: {},
  actions: {

    getConsultList (store, params) {
      return getConsultList(params)
    },

    addConsult (store, params) {
      return addConsult(params)
    },

    getConsultDetail (store, id) {
      return getConsultDetail(id)
    },

    editConsultDetail (store, {id, params}) {
      return editConsultDetail(id, params)
    },

    delConsult (store, params) {
      return delConsult(params)
    }

    // getbbslist (store, params) {
    //   return getbbslist(params)
    // },
    // getbbslistbyPro (store, params) {
    //   return getbbslistbyPro(params)
    // },
    // addbbs (store, params) {
    //   return addbbs(params)
    // },
    // getbbsDetail (store, {id}) {
    //   return getbbsDetail(id)
    // },
    // delbbs (store, params) {
    //   return delbbs(params)
    // },
    // approvalbbs (store, params) {
    //   return approvalbbs(params)
    // },
    // approvaldownbbs (store, params) {
    //   return approvaldownbbs(params)
    // },
    // editbbs (store, {postId, params}) {
    //   return editbbs(postId, params)
    // }
  }
}
